<template>
  <div class="h-100 d-flex align-items-center justify-content-center">
    <el-empty description="开发中" />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped></style>
